import { build, getOutput } from '@/api/system'

export default {
    components: {
    },
    props: {
        showBuildForm: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            completed: true,
            model: {},
            output: '',
            rules: {
                type: [ { required: true, message: '请选择构建类型', trigger: 'change' }],
            }
        }
    },
    computed: {
        actType() {
            return this.model.id ? '修改' : '添加'
        }
    },
    mounted () {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.build()
            })
        },
        build() {
            this.completed = false
            this.loading = true
            this.output = null
            build(this.model).then(res => {
                this.$message.destroy()
                this.loading = false
                this.model.number = res.data.number
                if (res.data.number) {
                    this.getOutput()
                }
            }).catch(() => {
                this.loading = false
            })
        },
        getOutput(number) {
            getOutput(this.model).then(res => {
                if (res.data.txt) {
                    this.output = res.data.txt
                    const logBox = document.getElementById('output')
                    logBox.scrollTop = logBox.scrollHeight
                }
                if (res.data.completed) {
                    this.completed = true
                    return this.$message.success('更新成功')
                }
                setTimeout(() => {
                    this.getOutput(number)
                }, 1000)
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showBuildForm', false)
        }
    }
}
